import { useEffect, useState } from 'react'
import { CommonConstant, CompetitionService } from 'utility'

export const GetCompetitionsList = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [total, setTotal] = useState(0)
  const [filter, setFilter] = useState({
    limit: CommonConstant.defaultPageSize,
    page: 0,
  })

  const fetchData = async () => {
    setLoading(true)
    try {
      const result = await CompetitionService.get(filter)
      setTotal(result.total)
      setData(result.list)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filter])

  const updateFilter = (key, value) => {
    setFilter({ ...filter, [key]: value })
  }

  const pageChanged = page => {
    setFilter({
      ...filter,
      page,
    })
  }

  const refetch = () => {
    fetchData()
  }

  return {
    data,
    setData,
    loading,
    error,
    total,
    updateFilter,
    filter,
    pageChanged,
    refetch,
  }
}

export const GetCompetitionById = Id => {
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchData = async id => {
    setLoading(true)
    try {
      const result = await CompetitionService.getById(id)
      setData(result)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (Id) {
      fetchData(Id)
    }
  }, [Id])

  return {
    data,
    setData,
    loading,
    error,
    fetchData,
  }
}

export const GetRoundDetailsById = (Id, roundNumber) => {
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchData = async id => {
    setLoading(true)
    try {
      const result = await CompetitionService.getRoundById(id, roundNumber)
      setData(result)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (Id) {
      fetchData(Id)
    }
  }, [Id])

  return {
    data,
    setData,
    loading,
    error,
    fetchData,
  }
}

export const GetRoundsByCompetition = Id => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchData = async id => {
    setLoading(true)
    try {
      const result = await CompetitionService.getRounds(id)
      setData(result.rounds)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (Id) {
      fetchData(Id)
    }
  }, [Id])

  return {
    data,
    setData,
    loading,
    error,
    fetchData,
  }
}

export const GetParticipantsCompetition = (Id) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchData = async (id, currentPage, currentPageSize) => {
    setLoading(true);
    try {
      const result = await CompetitionService.getCompetitionParticipants(id, currentPage, currentPageSize);
      setData((prevData) => [...prevData, ...result]);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (Id) {
      setData([]);
      setPage(1);
      setPageSize(10);
      fetchData(Id, 1, 10);
    }
  }, [Id]);

  const loadMore = () => {
    const newPageSize = pageSize + 10;
    setPageSize(newPageSize);
    fetchData(Id, page, newPageSize);
  };

  return {
    data,
    loading,
    error,
    fetchData,
    loadMore,
  };
};

export const GetSelectWinnerData = (id, round, flag) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({ page: 0, limit: 10, type: 'all' });
  const [total, setTotal] = useState(0);
  const [winners, setWinners] = useState(0)
  const [competition,setCompetition] = useState("")
  const fetchData = async () => {
    if (!id || !round) return;
    setLoading(true);
    try {
      const result = await CompetitionService.getSelectWinners(id, round, filters);
      setData(result?.creators || []);
      setTotal(result?.total || 0);
      setWinners(result?.no_of_winners || 0);
      setCompetition(result?.competitionName)
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id, round, filters, flag]);

  const updateFilters = (key, value) => {
    setFilters((prevFilters) => {
      if (typeof key === "object") {
        return { ...prevFilters, ...key };
      }
      return { ...prevFilters, [key]: value };
    });
  };

  const pageChanged = (page) => {
    setFilters(prevFilters => ({ ...prevFilters, page }));
  };

  return {
    data,
    loading,
    error,
    total,
    filters,
    updateFilters,
    pageChanged,
    refetch: fetchData,
    winners,
    competition,
  };
};

export const GetLeaderboardData = (Id, round) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [filter,setFilter] = useState({})
  const fetchData = async (id, round) => {
    setLoading(true)
    try {
      const result = await CompetitionService.getLeaderboardList(id, round,filter)
      setData(result?.leaderboard)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (Id) {
      fetchData(Id, round)
    }
  }, [Id, round,filter])

  const updateFilter = (key, value) => {
    setFilter((prevFilters) => {
      if (typeof key === "object") {
        return { ...prevFilters, ...key };
      }
      return { ...prevFilters, [key]: value };
    });
  };

  return {
    data,
    setData,
    loading,
    error,
    updateFilter,
    fetchData,
  }
}

export const GetVideoByRound = (Id, roundNumber) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState({
    limit: 9,
    page: 0,
  });
  const [prevDataLength, setPrevDataLength] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const fetchData = async (isLoadMore = false) => {
    if (!hasMore) return;
    setLoading(true);

    try {
      const result = await CompetitionService.getVideoByRound(Id, roundNumber, filter);

      setData(prevData => (isLoadMore ? [...prevData, ...result] : result));

      if (result.length === prevDataLength) {
        setHasMore(false);
      } else {
        setPrevDataLength(result.length);
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [Id, filter]);

  const loadMore = () => {
    if (!hasMore) return;
    setFilter(prevFilter => ({
      ...prevFilter,
      limit: prevFilter.limit + 3,
    }));
  };

  const refetch = () => {
    setHasMore(true);
    setFilter({ limit: CommonConstant.defaultPageSize, page: 0 });
    fetchData();
  };

  return {
    data,
    setData,
    loading,
    error,
    filter,
    loadMore,
    refetch,
    hasMore,
  };
};

export const GetCompetitionsByUserId = (id) => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [total, setTotal] = useState(0)
  const [filter, setFilter] = useState({
    limit: CommonConstant.defaultPageSize,
    page: 0,
  })

  const fetchData = async () => {
    setLoading(true)
    try {
      const result = await CompetitionService.getCompetitionsByUserId(id)
      setTotal(result?.total)
      setData(result.competitions)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (id) {
      fetchData()
    }
  }, [filter, id])

  const updateFilter = (key, value) => {
    setFilter({ ...filter, [key]: value })
  }

  const pageChanged = page => {
    setFilter({
      ...filter,
      page,
    })
  }

  const refetch = () => {
    fetchData()
  }

  return {
    data,
    setData,
    loading,
    error,
    total,
    updateFilter,
    filter,
    pageChanged,
    refetch,
  }
}
// export const GetCompetitionsByUserId = (id) => {
//   const [data, setData] = useState([])
//   const [loading, setLoading] = useState(false)
//   const [error, setError] = useState(null)
//   const [total, setTotal] = useState(0)
//   const [page, setPage] = useState(0) // Track current page

//   const fetchData = async (nextPage = 0, append = false) => {
//     if (!id) return

//     setLoading(true)
//     try {
//       const result = await CompetitionService.getCompetitionsByUserId(id, {
//         limit: CommonConstant.defaultPageSize,
//         page: nextPage,
//       })
//       setTotal(result?.total)
//       if (append) {
//         setData(prevData => [...prevData, ...result.competitions]) // Append new data
//       } else {
//         setData(result.competitions) // Replace data on first fetch
//       }
//     } catch (error) {
//       setError(error)
//     } finally {
//       setLoading(false)
//     }
//   }

//   useEffect(() => {
//     fetchData()
//   }, [id])

//   const loadMore = () => {
//     const nextPage = page + 1
//     setPage(nextPage)
//     fetchData(nextPage, true) // Fetch next page and append data
//   }

//   return {
//     data,
//     loading,
//     error,
//     total,
//     loadMore,
//   }
// }